export default "__VITE_ASSET__a31ef4fd__"